import { parseSqlAst } from '@vendia/management-api-common/src/sql/flora-parser'
import { LakehouseConnectionTypeEnum } from '@vendia/management-api-types'
import { Table } from 'src/types/types'

export interface SourceTableInfo {
  tableName?: string | undefined
  connectionType: LakehouseConnectionTypeEnum
  keyColumns?: string[]
  lastUpdatedColumn?: string
  fileName?: string
  connectionId?: string
  joinQuery?: any
}

export function getSourceTableInfo(table: Table): SourceTableInfo | null {
  if (table.source?.definition) {
    const { definition } = table.source

    if (definition.snowflake) {
      return {
        connectionType: LakehouseConnectionTypeEnum.Snowflake,
        ...definition.snowflake,
      }
    }

    if (definition.postgres) {
      return {
        connectionType: LakehouseConnectionTypeEnum.Postgres,
        ...definition.postgres,
      }
    }

    if (definition.cloudera) {
      return {
        connectionType: LakehouseConnectionTypeEnum.Cloudera,
        ...definition.cloudera,
      }
    }

    if (definition.vendia) {
      return {
        tableName: definition.vendia.tableName,
        connectionType: LakehouseConnectionTypeEnum.Vendia,
        joinQuery: definition.vendia.joinQuery ? parseSqlAst(definition.vendia.joinQuery) : undefined,
      }
    }

    if (definition.upload) {
      return {
        tableName: definition.upload.fileName,
        connectionType: LakehouseConnectionTypeEnum.Upload,
        fileName: definition.upload.fileName,
      }
    }

    if (definition.s3) {
      return {
        tableName: definition.s3.fileName,
        connectionType: LakehouseConnectionTypeEnum.S3,
        fileName: definition.s3.fileName,
      }
    }

    if (definition.mysql) {
      return {
        connectionType: LakehouseConnectionTypeEnum.Mysql,
        ...definition.mysql,
      }
    }

    if (definition.databricks) {
      return {
        connectionType: LakehouseConnectionTypeEnum.Databricks,
        ...definition.databricks,
      }
    }

    if (definition.bigquery) {
      return {
        connectionType: LakehouseConnectionTypeEnum.Bigquery,
        ...definition.bigquery,
      }
    }
  }

  return null
}
